// class CartNotification extends HTMLElement {
//   constructor() {
//     super();

//     this.notification = document.getElementById('cart-notification');
//     this.header = document.querySelector('sticky-header');
//     this.onBodyClick = this.handleBodyClick.bind(this);

//     this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
//     this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
//       closeButton.addEventListener('click', this.close.bind(this))
//     );
//   }

//   open() {
//     this.notification.classList.add('animate', 'active');

//     this.notification.addEventListener(
//       'transitionend',
//       () => {
//         this.notification.focus();
//         trapFocus(this.notification);
//       },
//       { once: true }
//     );

//     document.body.addEventListener('click', this.onBodyClick);
//   }

//   close() {
//     this.notification.classList.remove('active');
//     document.body.removeEventListener('click', this.onBodyClick);

//     removeTrapFocus(this.activeElement);
//   }

//   renderContents(parsedState) {
//     this.cartItemKey = parsedState.key;
//     this.getSectionsToRender().forEach((section) => {
//       document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
//         parsedState.sections[section.id],
//         section.selector
//       );
//     });

//     if (this.header) this.header.reveal();
//     this.open();
//   }

//   getSectionsToRender() {
//     return [
//       {
//         id: 'cart-notification-product',
//         selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
//       },
//       {
//         id: 'cart-notification-button',
//       },
//       {
//         id: 'cart-icon-bubble',
//       },
//     ];
//   }

//   getSectionInnerHTML(html, selector = '.shopify-section') {
//     return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
//   }

//   handleBodyClick(evt) {
//     const target = evt.target;
//     if (target !== this.notification && !target.closest('cart-notification')) {
//       const disclosure = target.closest('details-disclosure, header-menu');
//       this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
//       this.close();
//     }
//   }

//   setActiveElement(element) {
//     this.activeElement = element;
//   }
// }

// customElements.define('cart-notification', CartNotification);


// class CartNotification extends HTMLElement {
//   constructor() {
//     super();
//     this.notification = document.createElement('div');
//     this.notification.className = 'cart-notification';
//     this.notification.innerHTML = `
//       <div class="cart-notification__header">
//         <h2 class="cart-notification__heading">Item added to your cart</h2>
//         <button type="button" class="cart-notification__close" aria-label="Close">×</button>
//       </div>
//       <div class="cart-notification__content"></div>
//     `;

//     this.appendChild(this.notification);
//     this.close = this.close.bind(this);
//     this.querySelector('.cart-notification__close').addEventListener('click', this.close);
//   }

//   open() {
//     this.notification.classList.add('animate', 'active');
//     this.timeout = setTimeout(() => {
//       this.close();
//     }, 5000);
//   }

//   close() {
//     this.notification.classList.remove('animate', 'active');
//     if (this.timeout) clearTimeout(this.timeout);
//   }

//   renderContents(cartData) {
//     const item = cartData.items[0];
//     this.querySelector('.cart-notification__content').innerHTML = `
//       <div class="cart-notification__product">
//         <img src="${item.featured_image.url}" alt="${item.title}" class="cart-notification__product-image">
//         <div>
//           <h3 class="cart-notification__product-title">${item.title}</h3>
//           <p class="cart-notification__count">Cart total: ${cartData.item_count} ${cartData.item_count === 1 ? 'item' : 'items'}</p>
//         </div>
//       </div>
//     `;
//   }
// }

// customElements.define('cart-notification', CartNotification);

// class CartHandler {
//   constructor() {
//     this.cartNotification = document.querySelector('cart-notification');
//     this.productData = new Map();
//     this.cartCount = 0;
//     this.bindEvents();
//     this.initializeCartCount();
//   }

//   async initializeCartCount() {
//     try {
//       const response = await fetch('/cart.js');
//       if (!response.ok) throw new Error('Failed to fetch cart');
//       const cart = await response.json();
//       this.cartCount = cart.item_count;
//       this.updateCartUI(this.cartCount);
//     } catch (error) {
//       console.error('Error initializing cart:', error);
//     }
//   }

//   bindEvents() {
//     document.querySelectorAll('.cartAdd').forEach(button => {
//       button.addEventListener('click', (event) => this.handleAddToCart(event));
//     });

//     // Listen for cart updates from other sources
//     document.addEventListener('cart:updated', (event) => {
//       if (event.detail && event.detail.cartCount !== undefined) {
//         this.updateCartUI(event.detail.cartCount);
//       }
//     });
//   }

//   updateCartUI(count) {
//     this.cartCount = count;
//     document.querySelectorAll('.badge').forEach(badge => {
//       badge.textContent = count;
//       badge.classList.toggle('hidden', count === 0);
      
//       // Animate the badge
//       badge.classList.add('badge-update');
//       setTimeout(() => badge.classList.remove('badge-update'), 300);
//     });
//   }

//   async handleAddToCart(event) {
//     event.preventDefault();
//     const button = event.currentTarget;
//     button.setAttribute('disabled', 'true');
//     const iconBadge = button.querySelector('.icon-badge');
//     const productUrl = button.getAttribute('href');

//     try {
//       iconBadge?.classList.add('loading');

//       if (!this.productData.has(productUrl)) {
//         const response = await fetch(`${productUrl}.js`);
//         if (!response.ok) throw new Error('Failed to fetch product data');
//         const productData = await response.json();
//         this.productData.set(productUrl, productData);
//       }

//       const productData = this.productData.get(productUrl);
//       const availableVariant = productData.variants.find(variant => variant.available);
      
//       if (!availableVariant) {
//         this.showError('This product is not available.');
//         return;
//       }

//       const response = await fetch('/cart/add.js', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           items: [{ id: availableVariant.id, quantity: 1 }]
//         })
//       });

//       if (!response.ok) {
//         const errorDetails = await response.json();
//         throw new Error(errorDetails.description || 'Add to cart failed');
//       }

//       const cartData = await response.json();
//       const updatedCartResponse = await fetch('/cart.js');
//       const updatedCart = await updatedCartResponse.json();
      
//       this.updateCartUI(updatedCart.item_count);

//       if (this.cartNotification) {
//         cartData.item_count = updatedCart.item_count; // Ensure notification shows correct count
//         this.cartNotification.renderContents(cartData);
//         this.cartNotification.open();
//       }

//       // Dispatch event for other components that might need to know about cart updates
//       document.dispatchEvent(new CustomEvent('cart:updated', {
//         detail: { cartCount: updatedCart.item_count }
//       }));

//     } catch (error) {
//       console.error('Error:', error);
//       this.showError(error.message || 'Could not add item to cart. Please try again.');
//     } finally {
//       iconBadge?.classList.remove('loading');
//       button.removeAttribute('disabled');
//     }
//   }

//   showError(message) {
//     const errorDiv = document.createElement('div');
//     errorDiv.className = 'error-notification';
//     errorDiv.textContent = message;
//     document.body.appendChild(errorDiv);

//     setTimeout(() => errorDiv.remove(), 3000);
//   }
// }

// // Initialize cart handler
// document.addEventListener('DOMContentLoaded', () => {
//   new CartHandler();
// });

class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification') || document.createElement('div');
    this.notification.className = 'cart-notification';
    this.notification.innerHTML = `
      <div class="cart-notification__header">
        <h2 class="cart-notification__heading">Item added to your cart</h2>
        <button type="button" class="cart-notification__close" aria-label="Close">×</button>
      </div>
      <div class="cart-notification__content"></div>
      <div class="cart-notification__footer">
        <a href="/cart" class="cart-notification__link">View Cart</a>
      </div>
    `;

    if (!document.getElementById('cart-notification')) {
      this.appendChild(this.notification);
    }

    this.close = this.close.bind(this);
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close)
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);

    // Auto-close after 5 seconds
    this.timeout = setTimeout(() => {
      this.close();
    }, 5000);
  }

  close() {
    this.notification.classList.remove('animate', 'active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
    if (this.timeout) clearTimeout(this.timeout);
  }

  renderContents(cartData) {
    const item = cartData.items[0];

    this.querySelector('.cart-notification__content').innerHTML = `
      <div class="cart-notification__product">
        <img src="${item.featured_image.url}" alt="${item.title}" class="cart-notification__product-image">
        <div>
          <h3 class="cart-notification__product-title">${item.title}</h3>
          <p class="cart-notification__count">Cart total: ${cartData.item_count} ${cartData.item_count === 1 ? 'item' : 'items'}</p>
        </div>
      </div>
    `;

    this.open();
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }
}

customElements.define('cart-notification', CartNotification);

class CartHandler {
  constructor() {
    this.cartNotification = document.querySelector('cart-notification');
    this.productData = new Map();
    this.cartCount = 0;
    this.bindEvents();
    this.initializeCartCount();
  }

  async initializeCartCount() {
    try {
      const response = await fetch('/cart.js');
      if (!response.ok) throw new Error('Failed to fetch cart');
      const cart = await response.json();
      this.cartCount = cart.item_count;
      this.updateCartUI(this.cartCount);
    } catch (error) {
      console.error('Error initializing cart:', error);
    }
  }

  bindEvents() {
    document.querySelectorAll('.cartAdd').forEach(button => {
      button.addEventListener('click', (event) => this.handleAddToCart(event));
    });

    document.addEventListener('cart:updated', (event) => {
      if (event.detail && event.detail.cartCount !== undefined) {
        this.updateCartUI(event.detail.cartCount);
      }
    });
  }

  updateCartUI(count) {
    this.cartCount = count;
    document.querySelectorAll('.badge').forEach(badge => {
      badge.textContent = count;
      badge.classList.toggle('hidden', count === 0);

      badge.classList.add('badge-update');
      setTimeout(() => badge.classList.remove('badge-update'), 300);
    });
  }

  async handleAddToCart(event) {
    event.preventDefault();
    const button = event.currentTarget;
    button.setAttribute('disabled', 'true');
    const iconBadge = button.querySelector('.icon-badge');
    const productUrl = button.getAttribute('href');

    try {
      iconBadge?.classList.add('loading');

      if (!this.productData.has(productUrl)) {
        const response = await fetch(`${productUrl}.js`);
        if (!response.ok) throw new Error('Failed to fetch product data');
        const productData = await response.json();
        this.productData.set(productUrl, productData);
      }

      const productData = this.productData.get(productUrl);
      const availableVariant = productData.variants.find(variant => variant.available);

      if (!availableVariant) {
        this.showError('This product is not available.');
        return;
      }

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: availableVariant.id, quantity: 1 }]
        })
      });

      if (!response.ok) {
        const errorDetails = await response.json();
        throw new Error(errorDetails.description || 'Add to cart failed');
      }

      const cartData = await response.json();
      const updatedCartResponse = await fetch('/cart.js');
      const updatedCart = await updatedCartResponse.json();

      this.updateCartUI(updatedCart.item_count);

      if (this.cartNotification) {
        cartData.item_count = updatedCart.item_count;
        this.cartNotification.renderContents(cartData);
      }

      document.dispatchEvent(new CustomEvent('cart:updated', {
        detail: { cartCount: updatedCart.item_count }
      }));

    } catch (error) {
      console.error('Error:', error);
      //this.showError(error.message || 'Could not add item to cart. Please try again.');
    } finally {
      iconBadge?.classList.remove('loading');
      button.removeAttribute('disabled');
    }
  }

  showError(message) {
    const errorDiv = document.createElement('div');
    errorDiv.className = 'error-notification';
    errorDiv.textContent = message;
    document.body.appendChild(errorDiv);

    setTimeout(() => errorDiv.remove(), 3000);
  }
}

// Initialize cart handler
document.addEventListener('DOMContentLoaded', () => {
  new CartHandler();
});





